import React from 'react';
import './Section2.css';
import icon1 from './icon1.png'; // Employees Don't Act
import icon2 from './icon2.png'; // Lack of engagement/data
import icon3 from './icon3.png'; // Scope 3 emissions
import icon4 from './icon4.png'; // Traditional CSR

const Section2 = () => {
  return (
    <div className="sustainability-section">
      <div className="problem-tag">
        🔥 THE PROBLEM
      </div>

      <h2>
        Why <span className="sustainability-highlight">Sustainability</span> <br /> Programs Fail?
      </h2>

      <div className="sustainability-cards-container">
        <div className="sustainability-card">
          <img src={icon1} alt="Employees Don't Act" />
          <p>Negligence <br /> from Employees</p>
        </div>

        <div className="sustainability-card">
          <img src={icon2} alt="Lack of engagement/data" />
          <p>Lack of <br />engagement/data</p>
        </div>

        <div className="sustainability-card">
          <img src={icon3} alt="Scope 3 emissions are hard to track" />
          <p>Scope 3 <br /> emissions are hard to track</p>
        </div>

        <div className="sustainability-card">
          <img src={icon4} alt="Traditional CSR tools fail" />
          <p>Traditional CSR <br /> tools fail at individual level</p>
        </div>
      </div>
    </div>
  );
};

export default Section2;
